// ConfirmationPage.js
import React from 'react';
import { useLocation } from 'react-router-dom';

const ConfirmationPage = () => {
    const location = useLocation();
    const { appointmentDetails } = location.state || {};

    if (!appointmentDetails) {
        return (
            <div className="bg-gray-900 text-white min-h-screen font-sans flex flex-col items-center justify-center p-4">
                <div className="bg-red-800 text-red-100 p-6 rounded-lg max-w-md text-center">
                    <h2 className="text-xl font-bold mb-2">Error</h2>
                    <p>No appointment details found. Please start a new booking session.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-900 text-white min-h-screen font-sans flex flex-col items-center justify-center p-4">
            <div className="w-full max-w-2xl mx-auto">
                <div className="bg-green-800 text-green-100 p-8 rounded-lg shadow-xl text-center animate-fade-in">
                    <div className="mb-6">
                        <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h1 className="text-3xl font-bold mb-2">Appointment Confirmed!</h1>
                        <p className="text-lg text-green-200">Your meeting has been successfully booked</p>
                    </div>

                    <div className="bg-green-700 p-6 rounded-lg mb-6">
                        <h2 className="text-xl font-semibold mb-4">Appointment Details</h2>
                        <div className="space-y-2 text-left">
                            <div className="flex justify-between">
                                <span className="font-medium">Date:</span>
                                <span>{appointmentDetails.date}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-medium">Time:</span>
                                <span>{appointmentDetails.time}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-medium">Attendee:</span>
                                <span>{appointmentDetails.attendeeName}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-medium">Email:</span>
                                <span>{appointmentDetails.attendeeEmail}</span>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-4">
                        <div className="bg-green-700 p-4 rounded-lg">
                            <h3 className="font-semibold mb-2">📅 Calendar File Downloaded</h3>
                            <p className="text-sm text-green-200">
                                An `appointment.ics` file has been downloaded to your device. 
                                Please open it to add the event to your personal calendar.
                            </p>
                        </div>

                        <div className="bg-green-700 p-4 rounded-lg">
                            <h3 className="font-semibold mb-2">✅ Session Complete</h3>
                            <p className="text-sm text-green-200">
                                Your booking session has been marked as used and is no longer valid for additional bookings.
                            </p>
                        </div>

                        <div className="bg-green-700 p-4 rounded-lg">
                            <h3 className="font-semibold mb-2">📧 What's Next?</h3>
                            <p className="text-sm text-green-200">
                                You should receive a confirmation email shortly. If you need to make any changes to your appointment, 
                                please contact your assessor directly.
                            </p>
                        </div>
                    </div>

                    <div className="mt-8 pt-6 border-t border-green-600">
                        <p className="text-sm text-green-300">
                            Thank you for booking with CST Training. We look forward to meeting with you!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationPage;
